<template>
  <base-modal :show="show" @close="close">
    <form v-if="showForm" class="form">
      <h2 class="modal__heading headingThree">Email Project</h2>
      <p class="paragraph">Please enter an email address to send your project to.</p>
      <p v-show="hasError">{{ errorMessage }}</p>
      <div class="form__row">
        <input v-model="email" type="email" name="new project" placeholder="Email address" required="required">
      </div>
      <button type="submit" class="button modal__button" @click.prevent="sendProject">Send</button>
    </form>
    <div v-if="showSent">
      <h2 class="modal__heading headingThree">Project sent.</h2>
      <p class="paragraph">Your project has been sent to: <strong>{{ email }}</strong>.</p>

      <p><a href="#!" class="button" @click.prevent="close">Continue browsing</a></p>
    </div>
  </base-modal>
</template>
<script>
import { eventBus } from "../app";
import axios from '../config/axios';

export default {
	props: {
		id: { 
			type: Number, 
			default: null
		}
	},
	data() {
		return {
			show: false,
			showForm: true,
			showSent: false,
			projectId: this.id,
			email: null,
			errorMessage: null,
		};
	},
	computed: {
		hasError() {
			return false;
		},
	},
	created() {
		eventBus.$on("email-project", this.open);
	},
	beforeDestroy() {
		eventBus.$off("email-project", this.open);
	},
	methods: {
		close() {
			this.show = false;
		},
		open() {
			this.reset();
			this.show = true;
		},
		reset() {
			this.email = null;
			this.showForm = true;
			this.showSent = false;
		},
		async sendProject() {
			const data = {
				id: this.projectId,
				email: this.email,
			};
			const response = await axios.post("/actions/projectbook/projects/send", data);
			if (response.data.success) {
				this.showForm = false;
				this.showSent = true;
			}
		},
	},
	template: "#modal-email-project-template",
};
</script>
